import { ReactNode } from 'react';
import styled from 'styled-components';
import { Card, flexColumn, FlexColumn } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { fontSize, space } from '@elementary/common-ui/style/utils';

export const Form = styled.form`
  ${flexColumn};
  gap: ${space('lg')};
  width: 100%;
`;

export const Frame = ({ children }: { children: ReactNode }) => (
  <Card>
    <FlexColumn sx={{ width: '100%' }}>{children}</FlexColumn>
  </Card>
);

export const FieldsContainer = styled(FlexColumn)`
  gap: ${space('xxl')};
`;

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.content.translucent.secondary};
  font-size: ${fontSize('md')};
  margin-bottom: ${space('sm')};
`;
